// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3r7v-","label":"Completed_label__21erK"};